const peliculasData = [];

peliculasData.push({

  id: 3,
  slug: "No-One-Will-Save-You",
  nombre: "No One Will Save You",
  sinopsis:
    "Brynn es una joven brillante que vive apartada de un vecindario que la ha aislado. Solitaria pero optimista, encuentra consuelo en el hogar donde creció, hasta que unos extraños ruidos la despiertan en mitad de la noche.",
  poster:
    "https://www.themoviedb.org/t/p/w600_and_h900_bestv2/udniPSAJS6RDarNgSBK8IUsFthf.jpg",
  release_date: "2023",
  subtitles: "https://trlvdsgn.website/img/dressed-to-kill-sbus.vtt",
  video_url:
    "https://streaming.trlvdsgn.website//wp-content/uploads/2023/10/no-one.mp4",
});

peliculasData.push({
  
  id: 2,
  slug: "the-innocents",
  nombre: "The innocents",
  sinopsis:
    "During the bright Nordic summer, a group of children reveal their dark and mysterious powers when the adults aren't looking. In this original and gripping supernatural thriller, playtime takes a dangerous turn.",
  poster:
    "https://m.media-amazon.com/images/M/MV5BNDgwNGFmMDMtNGQzMC00Mjc2LWFhNzItYWIxMGJlM2Q2MzZlXkEyXkFqcGdeQXVyODA0MjgyNzM@._V1_FMjpg_UX692_.jpg",
  release_date: "2021",
  subtitles: "https://trlvdsgn.website/img/dressed-to-kill-sbus.vtt",
  video_url:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2023/09/the-innocents.mp4",
});

peliculasData.push({
  id: 5,
  slug: "ocho-y-medio",
  nombre: "8½",
  sinopsis:
    "Después de obtener un éxito rotundo, un director de cine atraviesa una crisis de creatividad e intenta inútilmente hacer una nueva película. En esta situación, empieza a pasar revista a los hechos más importantes de su vida y a recordar a todas las mujeres a las que ha amado.",
  poster:
    "https://m.media-amazon.com/images/M/MV5BNTkzZTZjOTgtYjgzMS00MTdkLWE2NDAtNTVmM2I3MGYyM2I0XkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_FMjpg_UX1050_.jpg",
  release_date: "1963",
  subtitles: "https://trlvdsgn.website/img/dressed-to-kill-sbus.vtt",
  video_url:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2023/09/ocho-y-medio.mp4",
});

peliculasData.push({
  id: 1,
  slug: "dressed-to-kill",
  nombre: "Dressed to Kill",
  sinopsis:
    "Una misteriosa mujer rubia mata a uno de los pacientes de un psiquiatra, y luego va en busca de la única testigo.",
  poster:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2023/08/dressed-to-till-poster.jpg",
  release_date: "mayo-2023",
  subtitles: "https://trlvdsgn.website/img/dressed-to-kill-sbus.vtt",
  video_url:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2023/08/dressed-to-kill.mp4",
});

peliculasData.push({
  id: 6,
  slug: "enferma-de-mi",
  nombre: "Enferma de mi",
  sinopsis:
    "Signe y Thomas mantienen una relación de pareja malsana y competitiva, que toma un giro pernicioso cuando Thomas obtiene cierta notoriedad como artista contemporáneo. La reacción de Signe consistirá en inventarse un nuevo personaje y tratar a la desesperada de llamar la atención y suscitar la compasión para recuperar su estatus.",
  poster:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2023/07/enferma-de-mi-poster.jpg",
  release_date: "2023",
  subtitles: "https://trlvdsgn.website/img/dressed-to-kill-sbus.vtt",
  video_url:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2023/07/enferma-de-mi.mp4",
});

peliculasData.push({
  id: 7,
  slug: "lux-aeterna",
  nombre: "Lux Aeterna",
  sinopsis:
    "Two actresses, Béatrice Dalle and Charlotte Gainsbourg, are on a film set telling stories about witches - but that's not all. 'Lux Æterna' is also an essay on cinema, the love of film, and on-set hysterics.",
  poster:
    "https://m.media-amazon.com/images/M/MV5BNjcyYWEyOGItYzMwYi00YjA2LTk5MGUtZGM3Y2UzMGQ5ZmQ0XkEyXkFqcGdeQXVyMTY3NTY5OTcx._V1_FMjpg_UX630_.jpg",
  release_date: "2019",
  subtitles: "https://trlvdsgn.website/img/dressed-to-kill-sbus.vtt",
  video_url:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2023/06/lux-aeterna.mp4",
});

peliculasData.push({
  id: 8,
  slug: "vortex",
  nombre: "Vortex",
  sinopsis:
    "The last days of an elderly couple stricken by dementia.",
  poster:
    "https://m.media-amazon.com/images/M/MV5BNjMxYTFmNTctNDgyYi00NzQwLTk1NTItMmVkYjk5Yjc1NmI2XkEyXkFqcGdeQXVyMTAyMjQ3NzQ1._V1_FMjpg_UY2048_.jpg",
  release_date: "2021",
  subtitles: "https://trlvdsgn.website/img/dressed-to-kill-sbus.vtt",
  video_url:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2023/05/vortex.mp4",
});

peliculasData.push({
  id: 9,
  slug: "infinity-pool",
  nombre: "Infinity Pool",
  sinopsis:
    "James and Em Foster are enjoying an all-inclusive beach vacation in the fictional island of La Tolqa, when a fatal accident exposes the resort's perverse subculture of hedonistic tourism, reckless violence and surreal horrors.",
  poster:
    "https://m.media-amazon.com/images/M/MV5BZDQxZTY0ZDItY2Y0Yy00OTIzLTkwYTgtNmNkODhiYTk4MzUwXkEyXkFqcGdeQXVyODE5NzE3OTE@._V1_FMjpg_UY3000_.jpg",
  release_date: "2023",
  subtitles: "https://trlvdsgn.website/img/dressed-to-kill-sbus.vtt",
  video_url:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2023/04/infinity.mp4",
});

peliculasData.push({
  id: 10,
  slug: "men",
  nombre: "Men",
  sinopsis:
    "Una joven se va de vacaciones sola a la campiña inglesa tras la muerte de su exmarido.",
  poster:
    "https://m.media-amazon.com/images/M/MV5BNDY2YjFiNDQtODdkZi00ZGIzLTk2NTQtMGY5YmUzMWIzYWYxXkEyXkFqcGdeQXVyNjM0MTI4Mw@@._V1_FMjpg_UX1125_.jpg",
  release_date: "2022",
  subtitles: "https://firebasestorage.googleapis.com/v0/b/cineclub-forever.appspot.com/o/men-subs.vtt?alt=media&token=fce6bfb5-44ee-44ec-a409-4bf2425deeb6",
  video_url:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2022/07/men.mp4",
});

peliculasData.push({
  id: 11,
  slug: "crimes-of-the-future",
  nombre: "Crimes of the Future",
  sinopsis:
    "La especie humana evoluciona y se adapta a un entorno sintético, el cuerpo es sometido a nuevas transformaciones y mutaciones. El artista Saul exhibe las metamorfósis de sus órganos en performances de vanguardia con su compañera Caprice.",
  poster:
    "https://m.media-amazon.com/images/M/MV5BNGQ1ZTc4ODgtZmUyNi00OGM5LThhYjAtYzZhMTQ2YjU1MDZlXkEyXkFqcGdeQXVyNjM0MTI4Mw@@._V1_FMjpg_UX1125_.jpg",
  release_date: "2022",
  subtitles: "https://trlvdsgn.website/img/dressed-to-kill-sbus.vtt",
  video_url:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2022/07/crimes-of-the-future.mp4",
});

peliculasData.push({
  id: 12,
  slug: "the-fly",
  nombre: "The Fly",
  sinopsis:
    "Un científico brillante se convierte progresivamente en un híbrido entre hombre y mosca cuando uno de sus experimentos se trunca.",
  poster:
    "https://m.media-amazon.com/images/M/MV5BODcxMGMwOGEtMDUxMi00MzE5LTg4YTYtYjk1YjA4MzQxNTNlXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_FMjpg_UY2400_.jpg ",
  release_date: "2022",
  subtitles: "https://trlvdsgn.website/img/dressed-to-kill-sbus.vtt",
  video_url:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2022/03/the-fly.mp4",
});

peliculasData.push({
  id: 4,
  slug: "titane",
  nombre: "TITANE",
  sinopsis:
    "Es una película visualmente impactante y perturbadora que desafía las convenciones cinematográficas. La dirección de Julia Ducournau es audaz y arriesgada, y la actuación de Agathe Rousselle en el papel principal es extraordinaria.",
  poster:
    "https://m.media-amazon.com/images/M/MV5BNGJlMTVlYWQtYmM5OC00MDgwLTk3NzAtMGViY2VjOGU0YjlkXkEyXkFqcGdeQXVyMTkxNjUyNQ@@._V1_FMjpg_UX1101_.jpg",
  release_date: "mayo-2023",
  subtitles: "https://trlvdsgn.website/img/dressed-to-kill-sbus.vtt",
  video_url:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2021/12/Titane-1080-x264-yts.mp4",
});

peliculasData.push({
  id: 13,
  slug: "bad-boy-bubby",
  nombre: "Bad Boy Bubby",
  sinopsis:
    "Bubby consigue escapar tras 30 años en la pequeña habitación en que su madre le ha forzado a vivir y se embarca en una aventura nihilista en el mundo exterior.",
  poster:
    "https://m.media-amazon.com/images/M/MV5BOTgyNmZmMDAtMDAxMy00NjYwLWE2NmUtODgyOWE1ZDdjZDAzXkEyXkFqcGdeQXVyMTY1MTcxMzc@._V1_FMjpg_UY2020_.jpg",
  release_date: "2022",
  subtitles: "https://trlvdsgn.website/img/dressed-to-kill-sbus.vtt",
  video_url:
    "https://streaming.trlvdsgn.website/wp-content/uploads/2021/03/bad-boy-bubby-1993-1080.mp4",
});

export default peliculasData;
